export class CriteriaSearchCriteria {
    userId: number;
    criteriaName: string;
}
